import { Box, Button, Paper, Typography, TextField, CircularProgress } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import useStyles from './DisplayNameInternalNote.styles';
import api from '../../../services/api/base';
import useSnackbar from '../../../hooks/useSnackbar';
import { IDisplayName } from '../../../services/types';

interface IProps {
  displayName?: IDisplayName;
  saveFactory: (displayNameReviewId: number, note: string) => Promise<any>;
  onSave: (displayNameId: number, note: string) => void;
  onClose: () => void;
}

const InternalNote = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { displayName, onSave, saveFactory, onClose } = props;
  const displayNameId = displayName?.id;
  const displayNameReviewId = displayName?.review.id;

  const [text, setText] = useState<string>(displayName?.review.note || '');
  const [isPending, setIsPending] = useState<boolean>(false);

  const snackbar = useSnackbar();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const text = e.target.value as string;

    if (text !== undefined) {
      setText(text.substr(0, 1000));
    }
  };

  const handleSaveClick = async () => {
    if (!displayNameId || !displayNameReviewId) {
      return;
    }

    setIsPending(true);

    try {
      const result = await saveFactory(displayNameReviewId, text);

      if (api.isResponseSuccess(result)) {
        snackbar.success('Saved successfully.');

        onSave(displayNameId, text);
      } else {
        snackbar.error('The note cannot be saved.');
      }
    } catch (e) {
      snackbar.error(`The note cannot be saved. ${e.message}`);
    } finally {
      setIsPending(false);
    }
  };

  useEffect(() => setText(displayName?.review.note || ''), [displayName]);

  return (
    <Paper className={classes.wrap}>
      <Typography variant="h6">Internal note</Typography>
      <Typography className={classes.subtitle}>{`Display Name Id: ${displayNameId}`}</Typography>
      <Box className={classes.noteWrap}>
        <TextField
          disabled={isPending}
          multiline
          value={text}
          onChange={handleChange}
          placeholder="Please describe the user’s violation of the guideline or anything you’d like to report to us in Internal note."
          className={classes.note}
          InputProps={{
            disableUnderline: true,
          }}
        />
      </Box>
      <Box className={classes.buttonWrap}>
        <Button variant="text" color="default" className={classes.cancelButton} onClick={onClose}>
          CANCEL
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          style={{
            textTransform: 'uppercase',
          }}
          disabled={isPending}
        >
          {!isPending && 'Save'}
          {isPending && <CircularProgress className={classes.submitButtonProgress} size={24} />}
        </Button>
      </Box>
    </Paper>
  );
};

export default InternalNote;
